// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"b939992f","180":"5c594e7e","208":"9d3499e1","459":"1631b66c","774":"a8908521"}[chunkId] + ".chunk.js";
};